export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8817.d2637991.jpg";